module.exports = __webpack_public_path__ + "img/scene_bedtime_tw_big@2x.30a14b4e.png";